const t = {
  name: "Terminal2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25Z" fill="currentColor"/>
<path d="M5 5C5 3.34315 6.34315 2 8 2H16C17.6569 2 19 3.34315 19 5V19C19 20.6569 17.6569 22 16 22H8C6.34315 22 5 20.6569 5 19V5ZM7 5V12H17V5C17 4.44772 16.5523 4 16 4H8C7.44772 4 7 4.44772 7 5ZM17 14H7V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V14Z" fill="currentColor"/>
<path d="M21 5V14H23V5H21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Terminal2
};
